export enum UploadFileStatus {
    None = 0,
    Updated = 1,
    Deleted = 2,
}
